import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { FlashMessage } from '@/core/Flash';
import { AppStore } from '@/store';
import AppButton from '@/core/components/form/AppButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'TheFlashMessages',
  setup(__props) {

const store = useStore<AppStore>();

const messages = computed<FlashMessage[]>(() => store.state.flashMessages);

const remove = (id) => {
	store.commit('removeFlash', id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_TransitionGroup, {
    tag: "div",
    name: "flash",
    class: "flash-message-container"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (flash) => {
        return (_openBlock(), _createElementBlock("div", {
          key: flash.id,
          class: _normalizeClass(["flash-message", flash.type])
        }, [
          _createElementVNode("div", null, [
            (flash.title)
              ? (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(flash.title), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(flash.message), 1)
          ]),
          _createVNode(AppButton, {
            onClick: ($event: any) => (remove(flash.id)),
            class: "flash-message-remove",
            icon: "times",
            seamless: true
          }, null, 8, ["onClick"])
        ], 2))
      }), 128))
    ]),
    _: 1
  }))
}
}

})